import { Button } from "atoms/button/Button";

import { QuizStepProps } from "../useQuestionnaire";

import { TextAreaStep } from "./components/TextAreaStep";

export const WeightBmiGoal = (props: QuizStepProps) => {
  const hasError = !!props.errors?.GoalWeightBmi;
  return (
    <div className="flex h-full flex-col">
      <TextAreaStep
        label="Goal Weight or BMI"
        name="GoalWeightBmi"
        title="What is your goal weight or body mass index (BMI)? Please note that while this information is helpful, medical decisions will be made by the clinicians keeping clinical evidence and patient safety at the forefront."
        value={props.data.GoalWeightBmi as string}
        onChange={(name, value) => props.handleStepData(name, value)}
        error={hasError}
      />
      <div hidden={!hasError}>
        <p className="mt-2 text-sm text-red">
          Please enter your goal weight or BMI.
        </p>
      </div>
      <div className="mt-auto">
        <Button fullWidth onClick={props.next}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
